import request from '@/utils/request'

// 教育分类平铺列表(含上级名称)
export function listEduCategory(data) {
  return request({
    url: '/biz/admin/edu/category/list',
    method: 'post',
    data: data
  })
}

// 教育分类二级树
export function treeEduCategory(data) {
  return request({
    url: '/biz/admin/edu/category/tree',
    method: 'post',
    data: data
  })
}

// 教育分类详情
export function getEduCategory(data) {
  return request({
    url: '/biz/admin/edu/category/detail',
    method: 'post',
    data: data
  })
}

// 新增教育分类
export function addEduCategory(data) {
  return request({
    url: '/biz/admin/edu/category/add',
    method: 'post',
    data: data
  })
}

// 修改教育分类
export function updateEduCategory(data) {
  return request({
    url: '/biz/admin/edu/category/edit',
    method: 'post',
    data: data
  })
}

// 删除教育分类
export function delEduCategory(data) {
  return request({
    url: '/biz/admin/edu/category/delete',
    method: 'post',
    data: data
  })
}
